module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/contents/noimage_s120x120-d6e208a7bc4f93cbb2acfe1d972150bb.png";